import React, { useRef } from 'react'
import styled from 'styled-components'
import Pinger from './pinger'

const PRESENCE_COLOR_MAP = {
    red: 'rgba(219, 94, 72, 0.92)',
    green: 'rgba(138, 219, 72, 0.92)',
    blue: 'rgba(72, 155, 219, 0.92)',
    purple: 'rgba(153, 72, 219, 0.92)',
    orange: 'rgba(219, 170, 72, 0.92)',
}

const ClueNumberSpan = styled.span`
    position: absolute;
    top: 1px;
    left: 2px;
    font-size: 0.4em;
    color: #4a6054;

    @media only screen and (min-width: 1000px) {
        font-size: 0.4em !important;
    }
`

const Square = (props) => {
    const inputRef = useRef(null)
    const {
        text, filled, selected, correct, mistake, user, highlighted, onClick, onKeyDown, style,
        pingKey, onPing, clueNumber,
    } = props
    const presenceColor = user && PRESENCE_COLOR_MAP[user.color]
    const presenceStyle = {}
    if (!filled && presenceColor && !selected) {
        presenceStyle.borderColor = presenceColor
        presenceStyle.borderWidth = '1.5px'
        if (!correct && !mistake) {
            presenceStyle.backgroundColor = presenceColor
        }
    }

    return (
        <div
            onClick={onClick}
            className={[
                'Square',
                filled && 'filled',
                highlighted && 'highlighted',
                selected && 'selected',
                correct && !filled && 'correct',
                mistake && !filled && 'mistake',
            ].join(' ')}
            style={{ ...style, ...presenceStyle }}>
            <div
                ref={inputRef}
                className='InputText'
                onChange={e => {
                    let { value: key } = e.target
                    if (key.length > 1) {
                        key = key[key.length - 1]
                    }
                    onKeyDown({ key, preventDefault: () => null })
                }}
                >
                    <ClueNumberSpan>{clueNumber}</ClueNumberSpan>
                    {text}
                </div>
            <Pinger pingKey={pingKey} onPing={onPing} />
        </div>
    )
}

export default Square
